import React from 'react';
import styled from '@emotion/styled';
import MuiAlert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const AlertWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
`;

const AlertStyled = styled(MuiAlert)`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 0;
  font-size: 0.93rem;
  font-family: ${({ theme }) => theme.fonts.default};
  letter-spacing: 0;

  color: ${({ type }) => (type === 'error' ? '#d0021b' : '#417505')};
  background-color: ${({ type, theme }) => (type === 'error' ? '#f2dede' : theme.colors.success)};

  .MuiAlert-action {
    position: absolute;
    right: 1.4rem;
    cursor: pointer;
    color: #195d8d;
    font-size: 1.3rem;
  }
`;

const Alert = ({ show, type, children, onClose }) => {
  const COLLAPSE_ANIMATION_TIMEOUT = 500;

  return (
    <AlertWrapper>
      <Collapse in={show} timeout={{ enter: COLLAPSE_ANIMATION_TIMEOUT, exit: 0 }}>
        <AlertStyled
          icon={false}
          action={<FontAwesomeIcon onClick={onClose} icon={faTimesCircle} />}
          type={type}
        >
          {children}
        </AlertStyled>
      </Collapse>
    </AlertWrapper>
  );
};

export { Alert };
